import { gql } from "@apollo/client";

export const addLibraryVideo = gql`
  mutation addLibraryVideo($record: CreateOneLibraryVideoInput!) {
    libraryVideo_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;
